interface Props {
  canEdit: boolean;
}

export default function TableHeader({ canEdit }: Props) {
  return (
    <thead className='position-sticky top-0 ubbe-table-header'>
      <tr>
        <th
          scope='col'
          style={{ width: '10%' }}
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          Carrier
        </th>
        <th
          style={{ width: '10%' }}
          scope='col'
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          Fuel type
        </th>
        <th
          scope='col'
          style={{ width: '15%' }}
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          0 to 9,000
        </th>
        <th
          scope='col'
          style={{ width: '15%' }}
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          10,000 to 54,999
        </th>
        <th
          scope='col'
          style={{ width: '17%' }}
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          55,000 and Greater
        </th>
        <th
          scope='col'
          style={{ width: '23%' }}
          className={`text-start align-middle ubbe-table-heading-text`}
        >
          Date Range
        </th>
        {canEdit && (
          <th scope='col'></th>
        )}
      </tr>
    </thead>
  );
}
